
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortCode]",
      function () {
        return require("private-next-pages/[shortCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortCode]"])
      });
    }
  